// TocApi.js
// API functions for Table of Contents functionality

import { apiCall } from '../ApiUtils';

export const tocApi = {
  // Get all sections and documents organized for table of contents
  async getTocData(classContext) {
    // Use public endpoint for public users
    if (classContext?.is_public_view) {
      return await apiCall('/document-editor/public/toc', { method: 'GET' }, classContext);
    }
    return await apiCall('/document-editor/toc', { method: 'GET' }, classContext);
  },

  // Section Management
  async getSections(classContext) {
    return await apiCall('/document-editor/sections', { method: 'GET' }, classContext);
  },

  async createSection(name, description = '', parentSectionId = null, classContext) {
    return await apiCall('/document-editor/sections', {
      method: 'POST',
      body: JSON.stringify({
        name,
        description,
        parentSectionId
      })
    }, classContext);
  },

  async updateSection(sectionId, name, description = '', classContext) {
    return await apiCall(`/document-editor/sections/${sectionId}`, {
      method: 'PUT',
      body: JSON.stringify({
        name,
        description
      })
    }, classContext);
  },

  async reparentSection(sectionId, newParentId, classContext) {
    return await apiCall(`/document-editor/sections/${sectionId}/reparent`, {
      method: 'PATCH',
      body: JSON.stringify({ newParentId: newParentId ?? null })
    }, classContext);
  },

  async deleteSection(sectionId, classContext) {
    return await apiCall(`/document-editor/sections/${sectionId}`, { method: 'DELETE' }, classContext);
  },

  // Section Archiving
  async archiveSection(sectionId, classContext) {
    return await apiCall(`/document-editor/sections/${sectionId}/archive`, { method: 'PATCH' }, classContext);
  },

  async unarchiveSection(sectionId, classContext) {
    return await apiCall(`/document-editor/sections/${sectionId}/unarchive`, { method: 'PATCH' }, classContext);
  },

  // Document Archiving
  async archiveDocument(documentId, classContext) {
    return await apiCall(`/document-editor/documents/${documentId}/archive`, { method: 'PATCH' }, classContext);
  },

  async unarchiveDocument(documentId, classContext) {
    return await apiCall(`/document-editor/documents/${documentId}/unarchive`, { method: 'PATCH' }, classContext);
  },

  // Get Archived Items
  async getArchivedDocuments(classContext) {
    return await apiCall('/document-editor/documents/archived', { method: 'GET' }, classContext);
  },

  async getArchivedSections(classContext) {
    return await apiCall('/document-editor/sections/archived', { method: 'GET' }, classContext);
  },

  // Visibility Controls
  async toggleDocumentVisibility(documentId, classContext) {
    return await apiCall(`/document-editor/documents/${documentId}/toggle-visibility`, { method: 'PATCH' }, classContext);
  },

  async toggleSectionVisibility(sectionId, classContext) {
    return await apiCall(`/document-editor/sections/${sectionId}/toggle-visibility`, { method: 'PATCH' }, classContext);
  },

  // Drag and Drop Reordering
  async reorderItems(items, classContext) {
    return await apiCall('/document-editor/reorder', {
      method: 'POST',
      body: JSON.stringify({
        items
      })
    }, classContext);
  }
};